import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CertificateTypeForm from '../../../components/forms/CertificateTypeForm';
import { useCertificateTypeApi } from '../../../hooks/useCertificateTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CertificateTypeDTO } from '../../../services/apiClient';

const CertificateTypeEdit: React.FC = () => {
  const { getById, edit } = useCertificateTypeApi();
  const [entityData, setEntityData] = useState<CertificateTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Certificate Types', href: '/admin/certificatetypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CertificateType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/certificatetypes');
    } catch (error) {
      console.error('Error updating CertificateType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/certificatetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CertificateType.Edit"
    >
      {entityData ? (
        <CertificateTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/certificatetypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CertificateTypeEdit;
